import gql from 'graphql-tag';

export const CREATE_LEAD_PROPOSAL = gql`
  mutation CreateLeadProposal($input: CreateLeadProposalInput!) {
    leadProposal: createLeadProposal(input: $input) {
      id
      leadId
      success
      vendorGUID
      errorMessage
      vendorOpportunityId
    }
  }
`;
